module.exports = __webpack_public_path__ + "img/logo-pbb.81f6a9cd.png";